import './footer.css';

export default function Footer() {
    return (
        <div id="footer-container">
        <footer>
        <p>&copy; 2025 by Abdullah Goher. No rights reserved.</p>
        <nav>
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
            <a href="mailto:mgoher@seas.upenn.edu">Contact Us</a>
        </nav>
    </footer>
    </div>
    );
}